import { SearchConfig, SearchKey } from "../../../../types/search";

type OptionKeys = Extract<SearchKey, "buildingName" | "businessUnitId" | "ownerName">;

export const searchByOptions: SearchConfig<OptionKeys>[] = [
  { value: "buildingName", label: "Building Name", controlType: "text", default: true },
  { value: "businessUnitId", label: "Business Unit", controlType: "select" },
  { value: "ownerName", label: "Owner", controlType: "select" },
];
